import { effect, inject, runInInjectionContext, EnvironmentInjector } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { TranslateTriggerService } from '@app/core/i18n/services/translate-trigger.service';

export function initializeChart(): void {
  runInInjectionContext(inject(EnvironmentInjector), () => {
    Chart.register(...registerables);
    Chart.register(zoomPlugin);

    const translateTrigger = inject(TranslateTriggerService);
    effect(() => {
      Chart.defaults.locale = translateTrigger.currentLang();
    });
  });
}
